import { React, useState } from "react";
import "./navbar.css";
import Logo from "../../assets/logo.png";
import { RiMenu3Line, RiCloseLine } from "react-icons/ri";
import { Link } from "react-scroll";

const Menu = () => {
  return (
    <div className="navlist__container">
      <ul>
        <li>
          <Link to="about" smooth={true}>
            About Us
          </Link>
        </li>
        <li>
          <Link to="vision" smooth={true}>
            Vision
          </Link>
        </li>
        <li>
          <Link to="roadmap" smooth={true}>
            The Roadmap
          </Link>
        </li>
        <li>
          <a
            href="https://aman-kaushik.gitbook.io/dimension-whitepaper/"
            target="_blank"
          >
            Whitepaper
          </a>
        </li>
        <li>
          <button className="cta">Get in touch</button>
        </li>
      </ul>
    </div>
  );
};

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  return (
    <div className="navbar">
      <div className="logo__container">
        <a href="/" className="logo__link">
          <img className="logo" src={Logo} />{" "}
          {/* <span className="logo__text">imension</span> */}
        </a>
      </div>
      <div className="navbar__menu_container">
        <Menu />
      </div>
      <div className="mobile__menu">
        <RiMenu3Line
          className={ !toggleMenu  ? "closeline" : "closelinefixed"}
          size={27}
          onClick={() => setToggleMenu(!toggleMenu)}
        />
        {toggleMenu && <Menu />}
      </div>
    </div>
  );
};

export default Navbar;
